






















import Vue from 'vue'
import Chat from '../Chat'
import { Layout } from '@/types/layouts'
import { WidgetAsset } from '@/types/assets'

export default Vue.extend({
  name: 'WidgetWrapper',
  props: {
    widget: {
      type: Object as () => WidgetAsset,
      required: true
    },
    layout: {
      type: Object as () => Layout,
      required: true
    },
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    delay: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => ({
    widgetStyle: {},
    interval: null as null|NodeJS.Timeout
  }),
  mounted () {
    this.scaleWidget()
    this.interval = setInterval(this.scaleWidget, 2000)
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  computed: {
    url (): string {
      if (this.delay === 0) return this.widget.url

      const url = new URL(this.widget.url)
      if (!url.hostname.includes('.singular.')) return this.widget.url

      // in order to enable delayed updates, we need to add the params below
      url.searchParams.set('forceinteractivelayer', '1')
      // url.searchParams.set('syncgraphics', '2') // use timestamp property from request body
      url.searchParams.set('graphicsdelay', String(this.delay))

      return url.href
    },
    widgetkey (): string {
      const key = this.widget.reloadKey ?? 0
      return `${this.widget.id}_${key}`
    }
  },
  methods: {
    scaleWidget (): Partial<CSSStyleDeclaration> {
      const wrapper = this.$refs.wrapper as HTMLDivElement | undefined
      if (wrapper) {
        const scale = wrapper.clientWidth / 1920
        const ratio = wrapper.clientHeight / wrapper.clientWidth
        const height = 1920 * ratio
        this.widgetStyle = {
          width: '1920px',
          height: `${height}px`,
          'pointer-events': 'none',
          '-webkit-transform': `scale(${scale})`,
          '-webkit-transform-origin': '0 0'
        }
      }
      return {}
    }
  },
  components: {
    Chat
  }
})
